"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.versions = exports.liveFlags = exports.flags = exports.flagDescriptions = exports.finalizedFlags = exports.environment = void 0;
const flags_1 = require("./src/flags");
Object.defineProperty(exports, "finalizedFlags", { enumerable: true, get: function () { return flags_1.finalizedFlags; } });
Object.defineProperty(exports, "flagDescriptions", { enumerable: true, get: function () { return flags_1.flagDescriptions; } });
Object.defineProperty(exports, "flags", { enumerable: true, get: function () { return flags_1.flags; } });
Object.defineProperty(exports, "liveFlags", { enumerable: true, get: function () { return flags_1.liveFlags; } });
const versions = __importStar(require("./src/versions.json"));
exports.versions = versions;
const env = process.env.ENV;
let environment;
switch (env) {
    case 'production':
        exports.environment = environment = require('./src/environment.prod').environment;
        break;
    case 'staging':
        exports.environment = environment = require('./src/environment.staging').environment;
        break;
    case 'development':
        exports.environment = environment = require('./src/environment.dev').environment;
        break;
    default:
        exports.environment = environment = require('./src/environment.prod').environment;
}
